// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rounded-4[data-v-3a83adfc]{border-radius:4px;overflow:hidden}.flex-grow-1[data-v-3a83adfc]{flex-grow:1}.flex-shrink-0[data-v-3a83adfc]{flex-shrink:0}.item-total[data-v-3a83adfc]{min-width:72px;text-align:right}.offer-item a[data-v-3a83adfc]{color:#007bff;text-decoration:none}", ""]);
// Exports
module.exports = exports;
